'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('core-js/modules/web.dom.iterable');

const SPLIT_PAYMENT_TYPES = {
  CASH: "CASH",
  CARD: "CARD",
  GIFT_CARD: "GIFT",
  E_GIFT_CARD: "EGIFT",
  REWARD: "REWRD",
  OTHER: "OTHER"
};
const TRANSACTION_TYPES = {
  MOBILE: 0,
  CARD: 1,
  CASH: 2,
  TAB: 3,
  GIFT_CARD: 4,
  OTHER: 5,
  INVOICE: 6,
  REWARD: 7,
  SPLIT: 8
};
const SPLIT_PAYMENT_TRANSACTION_TYPES = {
  [SPLIT_PAYMENT_TYPES.CASH]: TRANSACTION_TYPES.CASH,
  [SPLIT_PAYMENT_TYPES.CARD]: TRANSACTION_TYPES.CARD,
  [SPLIT_PAYMENT_TYPES.GIFT_CARD]: TRANSACTION_TYPES.GIFT_CARD,
  [SPLIT_PAYMENT_TYPES.E_GIFT_CARD]: TRANSACTION_TYPES.GIFT_CARD,
  [SPLIT_PAYMENT_TYPES.REWARD]: TRANSACTION_TYPES.REWARD,
  [SPLIT_PAYMENT_TYPES.OTHER]: TRANSACTION_TYPES.OTHER
};
const PLATFORMS = {
  MOBILE: 0,
  REGISTER: 1,
  KIOSK: 2,
  WEB: 3
};
const SOURCE_TYPE = {
  CARD: "card",
  ONE_TIME_CARD: "onetime",
  NATIVE_PAY: "native",
  GIFT_CARD: "giftCard",
  DRIP_CARD: "drip"
};

var CheckoutConstants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    SPLIT_PAYMENT_TYPES: SPLIT_PAYMENT_TYPES,
    TRANSACTION_TYPES: TRANSACTION_TYPES,
    SPLIT_PAYMENT_TRANSACTION_TYPES: SPLIT_PAYMENT_TRANSACTION_TYPES,
    PLATFORMS: PLATFORMS,
    SOURCE_TYPE: SOURCE_TYPE
});

const CUSTOMIZATION_TYPES = {
  SINGLE_SELECT: 0,
  QUANTITY: 1,
  MULTI_SELECT: 2,
  MULTI_SELECT_QUANTITY: 3,
  MULTI_SELECT_FIXED: 4,
  VARIANT: 5
};
const CUSTOMIZATION_TYPE_FIELDS = [{
  label: "Single Select",
  value: 0
}, {
  label: "Single Select w/ Quantity",
  value: 1
}, {
  label: "Multi-Select",
  value: 2
}, {
  label: "Multi-Select w/ Quality",
  value: 3
}, {
  label: "Multi-Select w/ Fixed Price",
  value: 4
}];
const DISCOUNT_TYPES = {
  ORDER_AMOUNT: 0,
  ORDER_PERCENT: 1,
  PRODUCT_AMOUNT: 2,
  PRODUCT_PERCENT: 3
};
const AVAILABILITY_TYPES = {
  EVERYDAY: 0,
  WEEKDAYS: 1,
  WEEKENDS: 2,
  DAY_OF_WEEK: 3,
  CUSTOM: 4
};

var ProductConstants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    CUSTOMIZATION_TYPES: CUSTOMIZATION_TYPES,
    CUSTOMIZATION_TYPE_FIELDS: CUSTOMIZATION_TYPE_FIELDS,
    DISCOUNT_TYPES: DISCOUNT_TYPES,
    AVAILABILITY_TYPES: AVAILABILITY_TYPES
});

/**
 * Get cart total without tax
 *
 * @param cart          Items in cart
 */

function getTotalWithoutTax(cart) {
  let giftCards = cart.filter(item => item.ID === -5).reduce((accum, item) => accum + item.PRICE, 0);
  let price = cart.filter(item => item.ID !== -5).reduce((accum, product) => {
    let usedFixedCustomizations = new Set();
    let variant = product.CUSTOMIZATIONS.find(item => item.TYPE === CUSTOMIZATION_TYPES.VARIANT);
    let price = variant ? variant.PRICE : product.PRICE;
    let modifier = variant && variant.MODIFIER ? variant.MODIFIER : 1;
    return accum + product.CUSTOMIZATIONS.reduce((accum, item) => {
      if (item.TYPE && item.TYPE === CUSTOMIZATION_TYPES.MULTI_SELECT_FIXED) {
        if (usedFixedCustomizations.has(item.ID)) {
          return accum;
        }

        usedFixedCustomizations.add(item.ID);
        return accum + Math.floor(item.PRICE * modifier);
      }

      if (item.TYPE === CUSTOMIZATION_TYPES.VARIANT) {
        return accum;
      }

      return accum + Math.floor(item.PRICE * modifier) * item.QUANTITY;
    }, price);
  }, 0);
  return price + giftCards;
}
/**
 * Get cart tax amount
 *
 * @param cart              Cart
 * @param rate              Location tax rate
 * @return {number}
 */

function getTax(cart, rate) {
  return cart.filter(item => item.ID !== -5).reduce((accum, product) => {
    let usedFixedCustomizations = new Set();

    if (product.TAX_DISABLED) {
      return accum;
    }

    let variant = product.CUSTOMIZATIONS.find(item => item.TYPE === CUSTOMIZATION_TYPES.VARIANT);
    let price = variant ? variant.PRICE : product.PRICE;
    let modifier = variant && variant.MODIFIER ? variant.MODIFIER : 1;
    return accum + Math.round(product.CUSTOMIZATIONS.reduce((accum, item) => {
      if (item.TYPE && item.TYPE === CUSTOMIZATION_TYPES.MULTI_SELECT_FIXED) {
        if (usedFixedCustomizations.has(item.ID)) {
          return accum;
        }

        usedFixedCustomizations.add(item.ID);
        return accum + Math.floor(item.PRICE * modifier);
      }

      if (item.TYPE === CUSTOMIZATION_TYPES.VARIANT) {
        return accum;
      }

      return accum + Math.floor(item.PRICE * modifier) * item.QUANTITY;
    }, price) * (rate / 100));
  }, 0);
}
/**
 * Get cart total
 *
 * @param cart          Cart
 * @param rate          Tax rate
 * @return {*}
 */

function getTotal(cart, rate) {
  return getTotalWithoutTax(cart) + getTax(cart, rate);
}
function calculateSourceTotal(sources, total) {
  let amount = 0;

  for (let source of sources) {
    if (source.type === "card" || source.type === "native" || source.type === "onetime") {
      return null;
    }

    amount += source.amount;
  }

  if (amount >= total) {
    return null;
  }

  return total - amount;
}

var CheckoutHelper = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getTotalWithoutTax: getTotalWithoutTax,
    getTax: getTax,
    getTotal: getTotal,
    calculateSourceTotal: calculateSourceTotal
});



var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Constants: CheckoutConstants,
    Helpers: CheckoutHelper
});



var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Constants: ProductConstants
});

/**
 *
 * @type {{DENIED: string, IN_REVIEW: string, ACCEPTED: string, PENDING: string, REJECTED: string}}
 */
const TRADE_REQUEST_TYPES = {
  PENDING: "PND",
  // WAITING
  IN_REVIEW: "RVW",
  // ACCEPTED BY TARGET
  REJECTED: "RJD",
  // REJECTED
  DENIED: "DND",
  // DENIED
  ACCEPTED: "ACP" // EVERYTHING DONE

};

var SchedulingConstants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TRADE_REQUEST_TYPES: TRADE_REQUEST_TYPES
});



var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Constants: SchedulingConstants
});

const DEVICE_TYPES = {
  REGISTER: "RGSTR",
  KIOSK: "KIOSK",
  TICKET: "TICKT",
  TIME_CLOCK: "TMECK"
};

var PartnerConstants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    DEVICE_TYPES: DEVICE_TYPES
});



var index$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Constants: PartnerConstants
});

const ROLE_PERMISSIONS = {
  MENU_FULL: "MENU_FULL",
  TEAM_FULL: "TEAM_FULL",
  MARKETING_FULL: "MARKETING_FULL",
  SCHEDULING_FULL: "SCHEDULING_FULL",
  ACCOUNTING_FULL: "ACCOUNTING_FULL",
  POINT_OF_SALE_FULL: "POINT_OF_SALE_FULL",
  BANKING_FULL: "BANKING_FULL",
  ADMIN_FULL: "ADMIN_FULL",
  REPORTING_FULL: "REPORTING_FULL",
  INVOICES_FULL: "INVOICES_FULL",
  OPERATIONS_FULL: "OPERATIONS_FULL"
};
const PERMISSION_DESCRIPTION = {
  [ROLE_PERMISSIONS.MENU_FULL]: "Provides employees access to creating and editing roles.",
  [ROLE_PERMISSIONS.TEAM_FULL]: "Provides employees access to create and edit employees.",
  [ROLE_PERMISSIONS.MARKETING_FULL]: "Provides employees access to all marketing features.",
  [ROLE_PERMISSIONS.SCHEDULING_FULL]: "Provides employeess access to add new shifts, edit existing schedules, and publish changes.",
  [ROLE_PERMISSIONS.ACCOUNTING_FULL]: "Provides employees access to the accounting dashboard to categorize expenses and view all records.",
  [ROLE_PERMISSIONS.POINT_OF_SALE_FULL]: "Provides employees access to login to the point of sale app from any device using their phone number.",
  [ROLE_PERMISSIONS.BANKING_FULL]: "Provides employees access to view banking balance, transfers, and more.",
  [ROLE_PERMISSIONS.ADMIN_FULL]: "Provides employees with full administrator access.",
  [ROLE_PERMISSIONS.REPORTING_FULL]: "Provides employees access to view all business reports.",
  [ROLE_PERMISSIONS.INVOICES_FULL]: "Provides employees access to create, manage, and send out invoices.",
  [ROLE_PERMISSIONS.OPERATIONS_FULL]: "Provides employees access to edit/create checklists, manage inventory, and more."
};

var TeamConstants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ROLE_PERMISSIONS: ROLE_PERMISSIONS,
    PERMISSION_DESCRIPTION: PERMISSION_DESCRIPTION
});



var index$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Constants: TeamConstants
});

function calculateNetSales(orders) {
  return orders.reduce((accum, item) => {
    if (item.REFUND_ID !== null) {
      return accum;
    }

    return accum + item.SUBTOTAL;
  }, 0);
}
function calculateTotalCollected(orders) {
  return calculateSummary(orders).collected;
}
function calculateSummary(orders) {
  let gross = 0,
      discounts = 0,
      taxes = 0,
      refunds = 0,
      tips = 0,
      processing = 0;

  for (let order of orders) {
    gross += order.SUBTOTAL;
    discounts += order.DISCOUNTS;
    taxes += order.TAXES;
    tips += order.TIP_AMOUNT;
    processing += order.PROCESSING;

    if (order.REFUND_ID !== null) {
      refunds += isNaN(order.REFUND_ID) ? order.SUBTOTAL : parseInt(order.REFUND_ID);
    }
  }

  gross += discounts;
  let net = gross - discounts - refunds;
  let collected = net + taxes + tips - processing;
  return {
    gross,
    discounts,
    taxes,
    refunds,
    tips,
    net,
    collected,
    processing
  };
}

var ReportingHelper = /*#__PURE__*/Object.freeze({
    __proto__: null,
    calculateNetSales: calculateNetSales,
    calculateTotalCollected: calculateTotalCollected,
    calculateSummary: calculateSummary
});



var index$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Helpers: ReportingHelper
});



var BankingConstants = /*#__PURE__*/Object.freeze({
    __proto__: null
});

function getPayoutEstimate(isoDay) {
  switch (isoDay) {
    case 0:
      return "Wednesday";

    case 1:
      return "Thursday";

    case 2:
      return "Friday";

    case 3:
      return "Monday";

    case 4:
      return "Tuesday";

    case 5:
      return "Wednesday";

    case 6:
      return "Wednesday";
  }
}

var BankingHelper = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getPayoutEstimate: getPayoutEstimate
});



var index$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Constants: BankingConstants,
    Helpers: BankingHelper
});

const ISO_WEEK_DAYS = {
  MONDAY: 0,
  TUESDAY: 1,
  WEDNESDAY: 2,
  THURSDAY: 3,
  FRIDAY: 4,
  SATURDAY: 5,
  SUNDAY: 6
};

var Constants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ISO_WEEK_DAYS: ISO_WEEK_DAYS
});

exports.Banking = index$6;
exports.Checkout = index;
exports.Constants = Constants;
exports.Partner = index$3;
exports.Products = index$1;
exports.Reporting = index$5;
exports.Scheduling = index$2;
exports.Team = index$4;
